import { styled } from '@mui/material';
import TableCell from '@mui/material/TableCell';

const StyledColumnCell = styled(TableCell)(({ theme, align }) => ({
  textAlign: align || 'center',
  backgroundColor: theme.palette.primary.contrastBg,
  color: theme.palette.common.black,

  '.MuiTableSortLabel-root': {
    fontSize: '14px',
    color: theme.palette.common.white,
    '&:hover, &.Mui-active': {
      color: theme.palette.common.white,
      '> .MuiTableSortLabel-icon': {
        color: theme.palette.common.white,
      },
    },
    '> .MuiTableSortLabel-icon': {
      fontSize: '26px',
      margin: 0,
      opacity: 1,
    },
  },
}));

export default StyledColumnCell